'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { useMutation } from 'urql';
import { SetAvatar } from '@/graphql/mutations';
import type { Avatar } from '@/gql/graphql';
import { hapticFeedback } from '@tma.js/sdk';
import clsx from 'clsx';
import { viewport } from '@tma.js/sdk-react';
interface Props {
  current?: Avatar | null;
  onSelect: () => void;
}
const avatarList: Avatar[] = ['Aquamarine', 'Arctic', 'Azure', 'Emerald', 'Indigo', 'Mint', 'Neon', 'Ocean', 'Sapphire', 'Sky', 'Turquoise', 'Vivid'];
export default function AvatarSelectorModal(t0) {
  const $ = _c(23);
  const {
    current,
    onSelect
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  const [selected, setSelected] = useState(current ?? null);
  const [setAvatarResult, execSetAvatar] = useMutation(SetAvatar);
  let t1;
  if ($[0] !== execSetAvatar) {
    t1 = avatar => {
      setSelected(avatar);
      if (hapticFeedback.isSupported()) {
        hapticFeedback.selectionChanged();
      }
      execSetAvatar({
        avatar
      });
    };
    $[0] = execSetAvatar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSelect = t1;
  let t2;
  if ($[2] !== onSelect || $[3] !== setAvatarResult.data?.setAvatar || $[4] !== setAvatarResult.error) {
    t2 = () => {
      if (!setAvatarResult.error && setAvatarResult.data?.setAvatar) {
        onSelect();
      }
    };
    $[2] = onSelect;
    $[3] = setAvatarResult.data?.setAvatar;
    $[4] = setAvatarResult.error;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onSelect || $[7] !== setAvatarResult) {
    t3 = [onSelect, setAvatarResult];
    $[6] = onSelect;
    $[7] = setAvatarResult;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
    };
    t5 = [];
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== isVisible) {
    t6 = clsx("fixed inset-0 z-50 flex flex-col bg-background transition-all duration-500 ease-out", viewport.isFullscreen() && "py-16", isVisible ? "opacity-100" : "opacity-0");
    $[11] = isVisible;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="p-6 text-center"><h1 className="text-3xl">Choose your bird</h1><p className="text-muted mt-2">Your unique origami companion</p></div>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== handleSelect || $[15] !== selected || $[16] !== setAvatarResult.fetching) {
    t8 = avatarList.map(avatar_0 => <button key={avatar_0} onClick={() => handleSelect(avatar_0)} className={clsx("relative aspect-square w-full rounded-3xl overflow-hidden border-3 transition-all", selected === avatar_0 ? "border-primary shadow-2xl" : "border-transparent")}>{selected === avatar_0 && setAvatarResult.fetching && <div className="absolute inset-0 z-25 rounded-3xl bg-linear-to-b from-transparent to-secondary/50 animate-pulse" />}<Image src={`/avatars/${avatar_0.toLowerCase()}.png`} alt={avatar_0} fill={true} className="object-contain p-4 z-50" /><div className="absolute z-75 bottom-3 left-1/2 -translate-x-1/2 bg-surface/50 text-xs px-3 py-1 rounded-full">{avatar_0}</div></button>);
    $[14] = handleSelect;
    $[15] = selected;
    $[16] = setAvatarResult.fetching;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="flex-1 overflow-auto pt-4 pb-8 px-6 grid grid-cols-3 gap-4">{t8}</div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t9) {
    t10 = <div className={t6}>{t7}{t9}</div>;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}